//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";
import * as d3 from "d3";
import d3Locale from "d3-format/locale/en-US.json";
import { csvGenerator } from "@/utils/csvGenerator.js";


const DEFAULT_FORMAT = (value) =>
  value != null && value != undefined ? value : "N/A";

function formatNumber(num) {
  if (num !== null && num.toString().includes(".")) {
    return d3.format(",.2f")(num);
  } else {
    return d3.format(",")(num);
  }
}

export default {
  name: "GraphTable",
  props: ["tableClass", "data", "context"],
  components: {
    Table,
  },
  mounted: function () {
    d3Locale.thousands = " "
    d3Locale.nan = "N/A"
    d3.formatDefaultLocale(d3Locale);
  },
  data: () => ({
    separator: "horizontal",
    recordsTotal: 0,
    tableData: [],
    columns: [],
  }),
  methods: {
    exportData: function () {
      let exportContent = [];
      exportContent.push(this.columns.map(e => e.label))
      let data = this.tableData.map(e => Object.values(e))
      exportContent = exportContent.concat(data)

      csvGenerator.toCSV('tableExport.csv', exportContent);
    }
  },
  watch: {
    data: {
      immediate: true,
      handler: function () {
        this.tableData = [];
        this.recordsTotal = this.data.mainData.length;

        this.columns = [
          {
            name: "label",
            required: false,
            label: "Hierarquia de loja",
            align: "left",
            field: (row) => (row.label ? row.label : "N/A"),
            format: DEFAULT_FORMAT,
            sortable: false,
          },
          {
            name: "cy",
            required: false,
            label: this.context.year() - 1,
            align: "left",
            field: (row) => (row.valueMain ? row.valueMain : "N/A"),
            format: DEFAULT_FORMAT,
            sortable: false,
          },
          {
            name: "py",
            required: false,
            label: this.context.year(),
            align: "left",
            field: (row) => (row.valueSecondary ? row.valueSecondary : "N/A"),
            format: DEFAULT_FORMAT,
            sortable: false,
          },
        ];

        for (let i = 0; i < this.data.mainData.length; i++) {
          this.tableData.push({
            label: this.data.mainData[i].label,
            valueMain: formatNumber(this.data.mainData[i].value),
            valueSecondary: formatNumber(this.data.secondaryData[i].value)
          })
        }

        // this.columns.push({
        //   name: "Variation",
        //   required: false,
        //   label: "Variação",
        //   align: "left",
        //   field: (row) => (row.variation ? row.variation : "N/A"),
        //   format: DEFAULT_FORMAT,
        //   sortable: false,
        // })
      },
    },
  }
};
